import React from "react";

import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";

import PasswordForm from "./password-form";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";

const ChangePassword = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CHANGE_PASSWORD", "CHANGE_PASSWORD");
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CHANGE_PASSWORD")}
        subTitle={i18n.get("CHANGE_PASSWORD")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <PasswordForm />
    </ET3PageDiv>
  );
});
export default ChangePassword;
